import React, { useEffect } from 'react';
import { UserAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FacebookAuthProvider } from "firebase/auth";
// import Signin from './pages/Signin';
import { FacebookLoginButton,GoogleLoginButton,google
 } from 'react-social-login-buttons';
import PhoneInput from 'react-phone-number-input';
import { useState } from 'react';
import 'react-phone-number-input/style.css'
import Phonelogin from './phonenumber';
import itok from '../images/itok.png'
const Signin = () => {
  const { facebookSignIn,googleSignIn, user } = UserAuth();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      await googleSignIn();
    } catch (error) {
      console.log(error);
    }
  };
  const handleFacebookSignIn=async ()=>{
    try {
      await facebookSignIn();
    } catch (error) {
      console.log(error)
    }
  }
  const handlePhonesignin=async()=>{
    console.log(value);
    console.log('Hi')
  }
  useEffect(() => {
    if (user != null) {
      navigate('/account');
    }
  }, [user]);
  const [value, setValue] = useState()

  return (
    
    <div>
      <h1 className='text-center text-3xl font-bold py-8'>Sign in</h1>
      <div className='max-w-[440px] m-auto py-4'>
      <center>
        <img src={itok} className='loginlogo'></img>
         <Phonelogin></Phonelogin>


<p>Or</p>
<br></br>
</center>
        <GoogleLoginButton onClick={handleGoogleSignIn} />
        <FacebookLoginButton onClick={handleFacebookSignIn} />
      </div>
    </div>
  );
};

export default Signin;
